import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Input, Button, Typography, message, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";

const { Title, Text } = Typography;

const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 4rem);
  padding: 2rem;
  align-items: center;
  justify-content: center;
  background-color: #f4f6fb;
  flex-direction: column;
`;

const InviteSection = styled.div`
  max-width: 400px;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledButton = styled(Button)`
  width: 100%;
  padding: 0.75rem;
  font-weight: bold;
  border-radius: 8px;
  margin-top: 1rem;
`;

const AcceptInvite: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [processing, setProcessing] = useState<boolean>(false);
  const [passwordResetUrl, setPasswordResetUrl] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const params= useParams()

  useEffect(() => {
    const fetchInvite = async () => {
      try {
        // Get full pathname from URL (excluding domain)
        const currentPath = window.location.pathname;

        // Modify path to include "/api" right after the domain
        const apiPath = `${currentPath}`;

        // Send request to accept invite
        const response = await api.post(apiPath, {inviteToken: params.token});

        // Get passwordResetUrl from response
        setPasswordResetUrl(response.data.passwordResetLink);
        message.success("Invite accepted! You will be redirected to set your password if you have never set one before.");

        // Redirect to reset password page
        // setTimeout(() => {
        //   navigate(`${response.data.passwordResetLink}`);
        // }, 5000);
      } catch (err: any) {
        const errorMsg = err.response?.data?.message || "Failed to process invite.";
        setError(errorMsg);
        message.error(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    fetchInvite();
  }, [navigate]);

  return (
    <Container>
      <InviteSection>
        {loading ? (
          <Spin size="large" />
        ) : error ? (
          <Text type="danger">{error}</Text>
        ) : (
          <>
            <Title level={2}>Welcome to Wzee!</Title>
            <Text>We have accepted your invite. Click below to set your password.</Text>
            
            <Button type="primary" href={`${passwordResetUrl}`}>Set Password</Button>

          </>
        )}
      </InviteSection>
    </Container>
  );
};

export default AcceptInvite;
